import { documentDisableScroll, documentEnableScroll } from "../tools/layout/document";
type ModalContentName = 'backInStock' | 'sizeChart' | 'regionSelector' | 'shippingInfo' | 'prModal' | 'productModal';
type ModalObj = {name: ModalContentName, modalElem: HTMLElement, visible: boolean};

const SELECTOR_CLOSE = '[data-modal-close]';
const CLASS_VISIBLE = 'is-visible';
const VAL_ZINDEX = 50;


const modalsArray: ModalObj[] = [];
const modalContainer = document.querySelector('[data-modal-container]');
type OpenModalProps = {
  modalContentName : ModalContentName,
  maxWidth?: number,
  uniqueModalElement?: HTMLDivElement | null
  globalCloseCross?: boolean
  darkerBackground?: boolean
  noPadding?: boolean
}

const openModalCallbacks: {modalContentName: ModalContentName, callback: () => void}[] = []
const closeModalCallbacks: {modalContentName: ModalContentName, callback: () => void}[] = []

export const onModalOpen = (modalContentName: ModalContentName, callback: () => void) => openModalCallbacks.push({modalContentName, callback})
export const onModalClose = (modalContentName: ModalContentName, callback: () => void) => closeModalCallbacks.push({modalContentName, callback})

export const openModal = ({
  modalContentName, 
  maxWidth, 
  uniqueModalElement,
  globalCloseCross,
  darkerBackground
}: OpenModalProps) => {
  if(modalIsAlreadyOpen()) return;

  if(modalAlreadyExists()) {
    showExistingModal();
  } else {
    createAndShowModal();
  }


  // implementation

  function createAndShowModal(){

    const modalContent = uniqueModalElement || document.querySelector<HTMLElement>(`[data-modal-content=${modalContentName}]`)!;
    if(!modalContent) return;
    const modal = createModalInstance();
    modalsArray.push({
      name: modalContentName, 
      modalElem: modal,
      visible: false
    });
    modalContainer?.appendChild(modal);
    setTimeout(showExistingModal, 50);
  
    
    // implementation

    function createModalInstance(){
      const modal = document.createElement('div');
      modal.classList.add('c-modal');
      modal.setAttribute('data-modal', modalContentName);

      modalContent.classList.add('c-modal__content');
      if(maxWidth){
        modalContent.style.maxWidth = `${maxWidth}px`
      }

      if(uniqueModalElement) {
        modal.appendChild(modalContent.cloneNode(true));
      } else {
        modal.appendChild(modalContent);
      }

      if(globalCloseCross){
        let closeIcon = ''
        closeIcon = `${closeIcon}<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M15.625 4.375l-11.25 11.25M15.625 15.625L4.375 4.375" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
        let closeIconElement = document.createElement('button');
        closeIconElement.innerHTML = closeIcon;
        closeIconElement.classList.add('c-modal__close','is-global');
        closeIconElement.setAttribute('selector-close-icon',"");
        closeIconElement.addEventListener('click', () => closeModal(modalContentName));
        modal.appendChild(closeIconElement);
      }


      //Create overlay & append after the content
      const overlay = document.createElement('div');
      overlay.classList.add('c-modal__overlay');
      if(darkerBackground){
        overlay.classList.add('is-darker');
      }
      overlay.setAttribute('data-modal-overlay', '');
      modal.appendChild(overlay);

      //Close elements and events
      const modalClose = modal.querySelectorAll(SELECTOR_CLOSE);
      modalClose.forEach(close => close.addEventListener('click', () => closeModal(modalContentName)));

      const modalOverlay = modal.querySelector('[data-modal-overlay]')!;
      modalOverlay.addEventListener('click', () => closeModal(modalContentName));

      return modal;
    }
  }

  function modalAlreadyExists(){
    return modalsArray.some(m => m.name == modalContentName);
  }

  function showExistingModal(){
    const modal = getModal(modalContentName);
    fireOpenModalCallbacks();
    modal.visible = true;
    modal.modalElem.classList.add(CLASS_VISIBLE);
    modal.modalElem.style.zIndex = VAL_ZINDEX + modalsArray.filter(m => m.visible).length.toString();
    documentDisableScroll();
  }

  function fireOpenModalCallbacks(){
    openModalCallbacks.forEach(callback => {
      if(callback.modalContentName == modalContentName){
        callback.callback()
      }
    })
  }




  function modalIsAlreadyOpen(){
    return modalsArray.some(m => m.name == modalContentName && m.visible);
  }
}

export const closeModal = (modalContentName: ModalContentName) => {
  const modal: ModalObj = getModal(modalContentName);
  modal.visible = false;
  modal.modalElem.classList.remove(CLASS_VISIBLE);
  fireCloseModalCallbacks();
  

  if(modalsArray.every(m => !m.visible)){
    documentEnableScroll()
  }

  function fireCloseModalCallbacks(){
    closeModalCallbacks.forEach(callback => {
      if(callback.modalContentName == modalContentName){
        callback.callback()
      }
    })
  }
}


// utility

const getModal = (modalContentName: string): ModalObj => {
  return modalsArray.find(m => m.name == modalContentName)!;
}



